<template>
    <div class="product-variation col-12 product-single">
        <div class="ttn_content product_ttn_content">
            <notifications></notifications>
            <div class="container product-container p-0" style="max-width: 1005px">
                <div class="page-main-category" :data-classname="'product_cat_' + parentCategory.id " :class="product.categories.find(i => i.slug === 'uncategorized') ? 'uncategorized' : ''">{{ categories[0].name }}</div>
                <div class="row mb-5">
                    <div class="col-md-6 mb-5 mb-md-0">
                        <div class="product_slider single-product-slider topchange">
                            <div class="post-title-mobile d-sm-none">{{ product.title }}</div>
                            <div :id="product.attachments.length > 1 ? 'main-slider' : 'single-slider'">
                                <div :class="{'carousel carousel-main init-flickity': product.attachments.length >1}" :id="product.attachments.length > 1 ? 'main-carousel' : 'single-carousel'"  data-main="carousel-product-nav">
                                    <div v-for="attachment in product.attachments" class="carousel-cell" >
                                        <div class="post">
                                            <wrap-image :fancy="'product'" :prop-image="attachment" prop-size="large" prop-class="image-carousel"/>
                                            <div v-if="product.attachments.length >= 1 && attachment.name" class="post-title post-title d-sm-block d-none">{{ attachment.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="product.attachments.length > 1" id="carousel-product-huge-nav" data-main="main-carousel" class="carousel carousel-nav init-flickity-nav">
                                <div v-for="(attachment, key) in product.attachments" :class="isDisplayNone && key == 0 ? 'carousel-cell d-none' : 'carousel-cell'">
                                    <wrap-image :prop-image="attachment" v-on:clicked="changeAttrOptions"  prop-size="small" prop-class="not-fancy"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="product_details">
                            <h1 class="product_title">{{ product.title }}</h1>
                            <p v-if="product.excerpt" class="short_description" v-html="product.excerpt"></p>
                            <form class="variations_form cart" onSubmit="return false;" >
                                <table class="variations" v-if="selectedOptions">
                                    <tbody>
                                    <tr v-for="attr in attributes">
                                        <td class="label">
                                            <label :for="`attribute_${attr.slug}`">{{ attr.name }}</label>
                                        </td>
                                        <td class="value">
                                            <select class="variation" :class="{'no-select': attr.options.length === 1}" :name="attr.slug" :id="`attribute_${attr.slug}`" :data-id="attr.id" v-on:change="changeVariationOption">
                                                <option value="">Choose an Option</option>
                                                <option :data-id="option.id" :class="attr.options.length === 1 || (selectedOptions[attr.slug] && selectedOptions[attr.slug] === option.slug) ? 'selected' : ''" v-for="option in attr.options" :selected="attr.options.length === 1 || (selectedOptions[attr.slug] && selectedOptions[attr.slug] === option.slug)" :value="option.slug">{{ option.name }}</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="mobile-hide"></td>
                                        <td>
                                            <!-- // test commit -->
                                            <a class="reset_variations" v-if="selectedOptions && Object.keys(selectedOptions).length == attributes.length" v-on:click="changeVariationOption(null,0)">Clear Options</a>
                                            <a class="reset_variations" v-else style="font-size: 11px;">Choose Options to See Price & Add to Cart</a>
                                        </td>
                                    </tr>
                                    <tr v-if="isNotCombinationAvailable && selectedOptions && Object.keys(selectedOptions).length == attributes.length">
                                        <td class="unavalable-message" colspan="2"><a style="text-decoration: unset;" class="unavalable text-sorry-message font-weight-light">Sorry, the combination of options you have selected is unavailable. Please choose a different combination.</a></td>
                                    </tr>
                                    </tbody>
                                </table>

                                <add-to-cart
                                    :product="product"
                                    :cart-item="cartItem"
                                    :varaitions-price-show="1"
                                    :isadmin="isadmin"
                                />
                            </form>
                        </div>
                        <div class="mb-4 product-content">
                            <div v-if="product.content" class="w-100 ml-auto mr-auto post_excerpt" v-html="product.content"></div>
                        </div>
                        <div class="product_meta w-100">
                            <span v-if="sku" class="item-sku">SKU: {{ sku }}</span>
                            <span v-if="categories.length && !isUncategorized" class="item-sku">Category:
                                <a v-for="(category, index) in categories" :href="category.url">{{category.name}}{{ index + 1 < categories.length ? ', ' : ''}}</a>
                            </span>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <product-tabs :prop-product-id="product.id" :prop-description="product.description" :prop-preview="this.isPreview"/>
                </div>
                <div class="row mt-4">
                    <div class="col-md-6">
                        <div class="jason_box_mobile">
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <h4>Have any questions about this product?</h4>

                                        <div class="text-center">
                                            <img loading="lazy"   alt="Jason Tilton of Tilton Coffered Ceilings" width="150" height="150" src="/images/person/jason_tilton.jpg" class="mb-3" />
                                            <p class="name">Jason Tilton</p>
                                            <p class="position">President &amp; Inventor&nbsp;</p>
                                            <a href="mailto:jason@TiltonCofferedCeilings.com" class="mail_link">Jason@TiltonCofferedCeilings.com</a>
                                            <a href="tel:800-396-6410" class="phone_link">Call Me Now</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="getProductLinkedProducts.length" class="row">
                    <section>
                        <h2 class="linked_products_sec page-second-title w-100 mb-4 pl-3">You may also like...</h2>
                        <div class="col-6 col-sm-4 col-md-3 col-lg-3" v-for="linkedProduct in getProductLinkedProducts">
                            <product-list-item :prop-linked-product="linkedProduct"/>
                        </div>
                    </section>
                </div>
            </div>
            <div v-if="$store.getters.isSuperAdmin || $store.getters.isAdmin" class="row m-0">
                <div class="col-12">
                    <a target="_blank" :href="$data._configs.baseUrl  + '/admin/products/' + product.id + '/edit' ">Edit</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductTabs from "./ProductTabs";
import WrapImage from "../WrapImage";
import Notifications from "../Notifications";
import AddToCart from "../AddToCart";
import ProductListItem from "../cart/ProductListItem";
import {mapActions, mapGetters} from "vuex";

export default {
    name: 'product-huge-variations',
    props: ['propProduct','propIsadmin','propEndCapOptions','propPreview'],
    components: {
        AddToCart,
        Notifications,
        WrapImage,
        ProductTabs,
        ProductListItem
    },
    data() {
        return {
            selectedVariation: null,
            selectedOptions: null,
            selectedOptionsIds: {},
            isDisplayNone: 0,
            isNotCombinationAvailable: false,
            showVariationNotFound: false,
            dataLayerCount: 0,
            isPreview: this.propPreview,
        }
    },
    mounted() {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        const hiddableBlock = document.querySelector('.mobile-hidden')
        if (isMobile){
            hiddableBlock.style.display = "none"
        }
        window.onpopstate = (event) => {
            this.initSelectedOptions()
            this.getHugeVariation()
            this.showRedToSelect();
        };

        this.$nextTick(() => {
            this.initSelectedOptions()
            this.getHugeVariation()
            this.showRedToSelect();
        })
        this.productLinkedProducts(this.product)

        this.showRedToSelect();

        if(this.product.attachments && this.product.attachments.length > 1)
        {
            if(this.product.main_image && this.product.attachments[0].id == this.product.main_image.id)
            {
                this.isDisplayNone = 1;
            }
        }
    },
    updated (){
        this.dataLayerViewItem(this.selectedVariation);

        if(this.product.attachments && this.product.attachments.length > 1)
        {
            if(this.product.main_image && this.product.attachments[0].id == this.product.main_image.id)
            {
                this.isDisplayNone = 1;
            }
        }
    },
    computed: {
        ...mapGetters(['getProductLinkedProducts']),
        product() {
          return this.mapProductItem(this.propProduct)
        },
        endCapOptions() {
          return this.propEndCapOptions
        },
        attributes() {
          return this.product.attributes
        },
        isadmin() {
            return this.propIsadmin
        },
        sku() {
            let sku = '-'

            if(this.product.sku_pattern && this.selectedOptions && this.attributes.length === Object.keys(this.selectedOptions).length) {
                sku = '' + this.product.sku_pattern
                const selectedAttrKeys = Object.keys(this.selectedOptions)
                for(let i = 0; i < selectedAttrKeys.length; i++) {
                    let skuReplace = ''
                    const attribute = this.attributes.find(item => item.slug === selectedAttrKeys[i])
                    if(attribute) {
                        const selectedOptionData = attribute.options.find(item => item.slug === this.selectedOptions[attribute.slug])
                        if(selectedOptionData && selectedOptionData.sku_part) {
                            skuReplace = selectedOptionData.sku_part
                        }
                    }

                    sku = sku.replaceAll(`%${attribute.slug}%`, skuReplace)
                }
            }

            return sku
        },
        categories() {
            return this.product.categories.map(i => ({url: i.publish_url, name: i.name, slug: i.slug}))
        },
        cartItem() {
            return this.mapCartItem({product: this.product, variation: this.selectedVariation, options: this.selectedOptions, sku: this.sku , optionsIds: this.selectedOptionsIds})
        },
        parentCategory() {
            return this.product.categories[0].parent ? this.product.categories[0].parent : this.product.categories[0]
        },
        isUncategorized() {
            return this.categories.filter(i => i.slug === 'uncategorized').length
        }
    },
    methods: {
        ...mapActions(['productLinkedProducts']),
        dataLayerViewItem(selectedVariation,changeVariation = 0)
        {
            window.dataLayer = window.dataLayer || [];

            if(selectedVariation && (changeVariation == 1 || this.dataLayerCount == 0))
            {
                let products = [];
                let items = [];

                this.$store.state.data_layer_change_detail_view_eec.ecomm_prodid = selectedVariation ? selectedVariation.sku : "";
                this.$store.state.data_layer_change_detail_view_eec.ecomm_totalvalue = selectedVariation ? selectedVariation.price : "";
                this.$store.state.data_layer_view_item.ecommerce.value = selectedVariation ? selectedVariation.price : "";

                let options =  Object.values(this.selectedOptions);
                let category =  this.cartItem && this.cartItem.categories.length > 0 ? this.cartItem.categories[0].meta_title : "";

                products[0] = {};
                products[0].brand = "";
                products[0].category = category;
                products[0].id = this.cartItem ? this.cartItem.sku : "";
                products[0].name = this.cartItem ? this.cartItem.title : "";
                products[0].price = selectedVariation ? parseFloat(selectedVariation.price) : "";
                products[0].stocklevel = "";
                products[0].variant = options ? options.join(",") : "";

                items[0] = {};
                items[0].google_business_vertical = "retail";
                items[0].id = this.cartItem ? this.cartItem.sku : "";
                items[0].item_brand = "";
                items[0].item_category = category;
                items[0].item_id = selectedVariation ? selectedVariation.sku : "";
                items[0].item_name = this.cartItem ? this.cartItem.title : "";
                items[0].item_variant = options ? options.join(",") : "";
                items[0].price = selectedVariation ? parseFloat(selectedVariation.price) : "";

                this.$store.state.data_layer_change_detail_view_eec.ecommerce.detail.products = products;
                this.$store.state.data_layer_view_item.ecommerce.items = items;

                // for(let i=0; i<obj1Keys.length; i++) {
                //     window.dataLayer[i] = window.dataLayer[obj1Keys[i]];
                // }

                // for(let i=0; i<obj2Keys.length; i++) {
                //     window.dataLayer[i+obj1Keys.length] = this.$store.getters.changeDetailsDataLayer[obj2Keys[i]];
                // }

                window.dataLayer.push(this.$store.getters.changeDetailsDataLayer[0]);
                window.dataLayer.push(this.$store.getters.changeDetailsDataLayer[1]);

                this.dataLayerCount = 1;
            }
            else
            {
                this.$store.state.data_layer_change_detail_view_eec.ecomm_prodid = "";
                this.$store.state.data_layer_change_detail_view_eec.ecomm_totalvalue = "0.00";
                this.$store.state.data_layer_view_item.ecommerce.value = "0.00";
            }
        },
        initSelectedOptions() {

            if(location.search) {
                this.selectedOptions = {}
                for(let pair of (new URLSearchParams(location.search)).entries()) {
                    const attribute = pair[0].replace('attribute_', '')
                    if(this.product.availableOptions[attribute] &&
                        this.product.availableOptions[attribute].includes(pair[1])) {0
                        this.selectedOptions[attribute] = pair[1];
                    }
                }
            }
            else
            {
                this.selectedOptions = {}

                const defaultAttributes = Object.keys(this.product.defaultOptions)
                for(let i = 0; i < defaultAttributes.length; i++) {
                    if(this.product.availableOptions[defaultAttributes[i]] &&
                        this.product.availableOptions[defaultAttributes[i]].includes(this.product.defaultOptions[defaultAttributes[i]])) {
                        this.selectedOptions[defaultAttributes[i]] = this.product.defaultOptions[defaultAttributes[i]];
                    }
                }
            }

            this.selectSingleAttrOptions()

            if(this.selectedOptions['end-cap-type'])
            {
                this.getEndCapTypeVarations(this.selectedOptions['end-cap-type']);
            }

            setTimeout(() => {

                if(!this.selectedOptionsIds.length) {

                    this.selectedOptionsIds = {}
                    const defaultAttributes = Object.keys(this.product.defaultOptions)

                    for(let i = 0; i < defaultAttributes.length; i++) {
                        if(this.product.availableOptions[defaultAttributes[i]] &&
                            this.product.availableOptions[defaultAttributes[i]].includes(this.product.defaultOptions[defaultAttributes[i]])) {

                            var select = $('#attribute_'+defaultAttributes[i]);
                            var attrId = select.attr('data-id');
                            var option = select.find("option[value='"+this.product.defaultOptions[defaultAttributes[i]]+"']");
                            var optionId = option.attr('data-id');
                            this.selectedOptionsIds[attrId] = optionId;
                        }
                    }
                }

                for(let pair of (new URLSearchParams(location.search)).entries()) {
                    const attribute = pair[0].replace('attribute_', '')
                    if(this.product.availableOptions[attribute] &&
                        this.product.availableOptions[attribute].includes(pair[1])) {

                        if(pair[0].includes('attribute_')){
                            var select = $('#'+pair[0]);
                        }
                        else{
                            var select = $('#attribute_'+pair[0]);
                        }
                        var attrId = select.attr('data-id');
                        var option = select.find("option[value='"+pair[1]+"']");

                        var optionId = option.attr('data-id');
                        this.selectedOptionsIds[attrId] = optionId;
                    }
                }

            }, 100);
        },
        changeVariationOption($event,byJavaScript = 1) {

            let eventName = "";
            let eventValue = "";
            // test commit
            if($event && !byJavaScript){
                eventName = $event.name;
                eventValue = $event.value;
            }
            else if($event)
            {
                eventName = $event.target.name;
                eventValue = $event.target.value;
            }

            if(eventName == 'end-cap-type')
            {
                this.getEndCapTypeVarations(eventValue)
            }

            if($event) {
                var select = $('#attribute_'+eventName);
                var attrId = select.attr('data-id');
                var option = select.find("option[value='"+eventValue+"']");

                var optionId = option.attr('data-id');

                this.selectedOptions = Object.assign({}, this.selectedOptions, {[eventName]: eventValue});
                this.selectedOptionsIds = Object.assign({}, this.selectedOptionsIds, {[attrId]: optionId});
            } else {
                this.selectedOptions = {}
                this.selectedOptionsIds = {}
            }

            const uri = Object.keys(this.selectedOptions).filter(i => this.selectedOptions[i]).map(attr => `attribute_${attr}=${this.selectedOptions[attr]}`).join('&')

            this.selectSingleAttrOptions()

            window.history.pushState(null, null, `${location.pathname}${uri ? '?' + uri: ''}`);

            this.getHugeVariation();
            this.showRedToSelect();


            this.dataLayerViewItem(this.selectedVariation,1);
        },
        getEndCapTypeVarations(eventValue)
        {
            const attributesSelection = Object.values(this.endCapOptions);

            let endCapIndex = this.attributes.findIndex(item => item.slug === 'end-cap-quantity');

            if(endCapIndex)
            {
                let optionsTwo= [];
                let optionOne = [attributesSelection[0]];
                optionsTwo[0] = attributesSelection[1];
                optionsTwo[1] = attributesSelection[2];

                if(eventValue == 'none' && optionOne.length)
                {
                    this.attributes[endCapIndex].options = optionOne;
                    this.selectedOptions = Object.assign({}, this.selectedOptions, {[this.attributes[endCapIndex].slug]: optionOne[0].slug});
                    this.selectedOptionsIds = Object.assign({}, this.selectedOptionsIds, {[this.attributes[endCapIndex].id]: optionOne[0].id.toString()});
                }
                else if(optionsTwo[0])
                {
                    this.attributes[endCapIndex].options = optionsTwo;

                    this.selectedOptions = Object.assign({}, this.selectedOptions, {[this.attributes[endCapIndex].slug]: optionsTwo[0].slug});
                    this.selectedOptionsIds = Object.assign({}, this.selectedOptionsIds, {[this.attributes[endCapIndex].id]: optionsTwo[0].id.toString()});
                }
            }
        },
        selectSingleAttrOptions() {

            for(let i = 0; i < this.attributes.length; i++) {
                if(this.attributes[i].options.length === 1) {
                    this.selectedOptions[this.attributes[i].slug] = this.attributes[i].options[0].slug

                    setTimeout(() => {
                        var select = $('#attribute_'+this.attributes[i].slug);
                        var attrId = select.attr('data-id');
                        var option = select.find("option[value='"+this.attributes[i].options[0].slug+"']");

                        var optionId = option.attr('data-id');
                        this.selectedOptionsIds[attrId] = optionId;
                    }, 10);
                }
            }
        },
        getHugeVariation() {
            this.isNotCombinationAvailable = false
            let isValid = true;
            this.attributes.map(i => {if (!Object.keys(this.selectedOptions).includes(i.slug)) { isValid = false } })
            this.isNotCombinationAvailable = false
            if(isValid) {
                this.$store.commit('LOADING', true);
                this.isNotCombinationAvailable = false
                axios.post(`/get-huge-variation`, {productId: this.product.id, selectedOptions: this.selectedOptions}).then(({data}) => {
                    if(data && data.price) {
                        const [addImageIndex, addImage] = this.addSelectedImage()

                        // if(addImage){
                        //     this.product.attachments[0] = {...addImage.image,...{uid:addImage.uid}}

                        //     var selecetedOrignalImage = addImage.image.urls.original;
                        //     var selecetedLargeImage = addImage.image.urls.large;
                        //     setTimeout(function()
                        //     {
                        //         $('.data_fancy_box_fix img[src="'+selecetedOrignalImage+'"]').each(function() {
                        //             var $img = $(this);

                        //             var thumbSrc = $img.attr('src');
                        //             var imgAlt = $img.attr('alt');
                        //             var fullSrc = thumbSrc.replace(/-\d+x\d+\./, '.');
                        //             $(this).parents('a').attr('href',fullSrc);
                        //             $img.attr('data-src', fullSrc);
                        //             if($img.parents('.init-flickity[data-main="carousel-product-nav"]').length)
                        //             {
                        //                 $img.attr('data-caption', imgAlt);
                        //             }

                        //         });

                        //         $('.data_fancy_box_fix img[src="'+selecetedLargeImage+'"]').each(function() {
                        //                 var $img = $(this);

                        //                 var thumbSrc = $img.attr('src');
                        //                 var imgAlt = $img.attr('alt');
                        //                 var fullSrc = thumbSrc.replace(/-\d+x\d+\./, '.');
                        //                 $(this).parents('a').attr('href',fullSrc);
                        //                 $img.attr('data-src', fullSrc);
                        //                 if($img.parents('.init-flickity[data-main="carousel-product-nav"]').length)
                        //                 {
                        //                     $img.attr('data-caption', imgAlt);
                        //                 }
                        //         });
                        //     },100);
                        // }

                        const [imageIndex, image] = this.getSelectedImage()

                        if(imageIndex !== -1 && image) {
                            new Flickity( document.querySelector('#main-carousel'), this.constants.MAIN_FLICKITY_OPTIONS).select(imageIndex)
                        }
                        this.isNotCombinationAvailable = false
                        this.selectedVariation = {
                            price: data.price,
                            image: image,
                        }

                    } else {
                        this.isNotCombinationAvailable = true
                        this.selectedVariation = null
                        this.showVariationNotFound = true
                    }

                    this.$store.commit('LOADING', false);
                }).catch(e => {
                    this.selectedVariation = null
                    this.showVariationNotFound = true
                    this.isNotCombinationAvailable = true
                    this.$store.commit('LOADING', false);
                });
            } else {
                this.selectedVariation = null
                this.showVariationNotFound = false
                this.isNotCombinationAvailable = true
            }
        },
        changeAttrOptions($event) {
            if (!$event.uid) {
                return
            }

            const optionsChanged = $event.uid.split('_');

            for(let i = 0; i < optionsChanged.length; i++) {
                let option = optionsChanged[i].split('=')

                Vue.set(this.selectedOptions, option[0], option[1]);

                var select = $('#attribute_'+option[0]);
                var attrId = select.attr('data-id');
                var optionVal = select.find("option[value='"+option[1]+"']");

                var optionId = optionVal.attr('data-id');
                this.selectedOptionsIds[attrId] = optionId;
            }
            const uri = Object.keys(this.selectedOptions).filter(i => this.selectedOptions[i]).map(attr => `attribute_${attr}=${this.selectedOptions[attr]}`).join('&')

            this.selectSingleAttrOptions()

            window.history.pushState(null, null, `${location.pathname}${uri ? '?' + uri: ''}`);

            this.getHugeVariation()
            this.showRedToSelect();
            this.dataLayerViewItem(this.selectedVariation,1);

        },
        addSelectedImage() {
            const selectedOptionsValues = Object.values(this.selectedOptions)
            let imageIndex = -1
            let image = null

            for(let i = 0; i < this.product.variant_images.length; i++) {
                const attach = this.product.variant_images[i]
                imageIndex = i
                image = this.product.variant_images[i]
                if(attach.uid) {
                    const attachHashes = attach.uid.split('_')
                    for(let j = 0; j < attachHashes.length; j++) {
                        if(!selectedOptionsValues.includes(attachHashes[j].split('=')[1])) {
                            imageIndex = -1
                            image = null
                        }
                    }
                } else {
                    imageIndex = -1
                    image = null
                }

                if(imageIndex !== -1) {
                    break
                }
            }

            return [imageIndex, image]
        },
        getSelectedImage() {
            const selectedOptionsValues = Object.values(this.selectedOptions)
            let imageIndex = -1
            let image = null

            for(let i = 0; i < this.product.attachments.length; i++) {
                const attach = this.product.attachments[i]
                imageIndex = i
                image = this.product.attachments[i]
                if(attach.uid) {
                    const attachHashes = attach.uid.split('_')
                    for(let j = 0; j < attachHashes.length; j++) {
                        if(!selectedOptionsValues.includes(attachHashes[j].split('=')[1])) {
                            imageIndex = -1
                            image = null
                        }
                    }
                } else {
                    imageIndex = -1
                    image = null
                }

                if(imageIndex !== -1) {
                    break
                }
            }

            return [imageIndex, image]
        },
        showRedToSelect()
        {
            setTimeout(function()
            {
                $('.variation').each(function(){
                    if($(this).find('option').hasClass('selected'))
                    {

                        $(this).removeClass('show_red');
                    }
                    else
                    {
                        $(this).addClass('show_red');
                    }
                });
            },100)
        }
    },
}
</script>

<style scoped>
.product-variation .variations select.variation option:first-child {
    display: none;
}
select.no-select {
    pointer-events: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    line-height: 19px;
}
</style>
